// import Layout from "../../internal/Layout.vue";
import Layout from '../../internal/Layout.vue'
import BigDataPage from './index.vue'

const BigDataRoutes = {
  component: Layout,
  children: [
    {
      module: 'big_data',
      name: 'bigDataDashboard',
      path: '/',
      component: BigDataPage,
      meta: {
        module: 'big_data',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: false,
      },
    },
  ],
}

export default BigDataRoutes
